import SavedInLists from 'components/RichProfile/MyLists/SavedInLists/SavedInLists.f';
import { withSavedInListsProps } from 'viewModel/richProfile/myLists/savedInLists/withSavedInListsProps';

export default withSavedInListsProps(SavedInLists);
